export const ENTER_POSTCODE_INPUT = 'enter_postocode';
export const ENTER_SERVICE_INPUT = 'enter_service';